import { render, staticRenderFns } from "./center.vue?vue&type=template&id=e76ebf9a&scoped=true&"
import script from "./center.vue?vue&type=script&lang=js&"
export * from "./center.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e76ebf9a",
  null
  
)

export default component.exports